import { render, staticRenderFns } from "./ReportPublications.vue?vue&type=template&id=f0c7bb8e"
import script from "./ReportPublications.vue?vue&type=script&lang=js"
export * from "./ReportPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports